// extracted by mini-css-extract-plugin
export default {"status-icon":"qvIjeF7JXhrfZMi","success":"at83MZKD8Ga5KqZ","error":"e_raslLdhVYMxWi","checkmark-icon":"uVJTIq0BWTv0C49"};